export const emotion_values_data = {
    Anxiety: 0.8, // Anxiety of it's lie revealed
    Shaken: 0.7, // attachment to the detective
    Guilt: 0.6, // Guilt over the sin
};
